/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Security_Sign_In_BodyInputs */

const en_notifications_security_sign_in_body = /** @type {(inputs: Notifications_Security_Sign_In_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A new sign-in was detected on your account.`)
};

const pt_br2_notifications_security_sign_in_body = /** @type {(inputs: Notifications_Security_Sign_In_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Um novo acesso foi detectado na sua conta.`)
};

/**
* | output |
* | --- |
* | "A new sign-in was detected on your account." |
*
* @param {Notifications_Security_Sign_In_BodyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_security_sign_in_body = /** @type {((inputs?: Notifications_Security_Sign_In_BodyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Security_Sign_In_BodyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_security_sign_in_body(inputs)
	return pt_br2_notifications_security_sign_in_body(inputs)
});